import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Right, Search } from '../../../components/Icon';
import { Cell, List, Row } from '../../../components/List';
import { Loader } from '../../../components/Loader';
import { UserLabelById } from '../../Users/components/UserLabelById';
import { fetchVehicleHistory } from '../actions';
import { HBox, VBox } from '../../../components/Box';
import { Modal } from '../../../components/Modal';
import { HistoryLogsSearch } from '../components/SearchHistoryLogs';
import { selectVehicleHistoryLogs } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VEHICLE_HISTORY } from '../constants';

const Container = styled.div`
  .oldValue {
    width: 300px;
  }
  .newValue {
    width: 300px;
  }
`;

const DetailsRowName = styled.div`
  max-width: 30%;
  min-width: 30%;
`;

const DetailsRowValue = styled.div`
  max-width: 70%;
  min-width: 70%;
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleDetailsHistoryComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetch(this.callback(result => this.setState({ result })));
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  render() {
    if (this.props.work) return <Loader />;
    return (
      <Container>
        <div className="container-fluid p-0 mb-3">
          <HistoryLogsSearch
            vehicle={this.props.vehicle}
            weblogin={this.props.weblogin}
            webloginVehicles={this.props.webloginVehicles}
            filterVehicles={this.filterVehicles}
          />
        </div>

        <List>
          <Row isHeader>
            {['', 'user', 'createdAt', 'type', 'field', 'old', 'new'].map(name => (
              <Cell key={name}>{name}</Cell>
            ))}
          </Row>
          {this.props.historyLogs.map(this.renderRow.bind(this))}
        </List>
        {this.renderDetailsModal()}
      </Container>
    );
  }

  renderRow(item, index) {
    let payload = {};
    try {
      payload = JSON.parse(item.payload || '');
    } catch (error) {
      //
    }

    let newValue = null;

    if (item.actionType == 'document_added') {
      newValue = payload.newValue.description;
    } else {
      newValue = payload.newValue || '';
    }

    return (
      <Row key={item.id}>
        <Cell>
          <div onClick={this.showDetails.bind(this)} data-key={item.id}>
            <Search />
          </div>
        </Cell>
        <Cell>
          <UserLabelById user_id={item.updatedById} />
        </Cell>
        <Cell>{item.createdAt}</Cell>
        <Cell>{item.actionType}</Cell>
        <Cell>{item.field}</Cell>
        <Cell className="oldValue">{`${JSON.stringify(payload.oldValue).substring(0, 200) ?? null}`}</Cell>
        <Cell className="newValue">
          <Right /> {`${JSON.stringify(payload.newValue)?.substring(0, 200) ?? null}`}
        </Cell>
      </Row>
    );
  }

  showDetails(evt) {
    let key = evt.currentTarget.getAttribute('data-key');
    if (key) key = parseInt(key, 10);
    this.setState({ showDetailsFor: key });
  }

  renderDetailsModal() {
    const itemKey = this.state.showDetailsFor;
    if (!itemKey) return;
    const item = (this.props.historyLogs ?? []).find(i => i.id === itemKey);
    if (!item) return;

    return (
      <Modal onClose={this.closeDetailsModal.bind(this)}>
        <VBox>
          <HBox>
            <DetailsRowName>browser</DetailsRowName>
            <DetailsRowValue>{item.browser}</DetailsRowValue>
          </HBox>
          <HBox>
            <DetailsRowName>ipV4</DetailsRowName>
            <DetailsRowValue>{item.ipV4}</DetailsRowValue>
          </HBox>
          <HBox>
            <DetailsRowName>ipV6</DetailsRowName>
            <DetailsRowValue>{item.ipV6}</DetailsRowValue>
          </HBox>
          <HBox>
            <DetailsRowName>service</DetailsRowName>
            <DetailsRowValue>{item.service}</DetailsRowValue>
          </HBox>
        </VBox>
      </Modal>
    );
  }

  closeDetailsModal() {
    this.setState({ showDetailsFor: null });
  }
}

VehicleDetailsHistoryComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    historyLogs: selectVehicleHistoryLogs(),
    work: selectWork(REQUEST_VEHICLE_HISTORY),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(callback) {
      dispatch(fetchVehicleHistory(ownProps.vehicle.id, '', [], callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsHistory = compose(withConnect, withRouter)(VehicleDetailsHistoryComp);
